import { render, staticRenderFns } from "./UOttawaTask5.vue?vue&type=template&id=35f6f7fe&scoped=true&"
import script from "./UOttawaTask5.vue?vue&type=script&lang=ts&"
export * from "./UOttawaTask5.vue?vue&type=script&lang=ts&"
import style0 from "./UOttawaTask5.vue?vue&type=style&index=0&id=35f6f7fe&prod&scoped=true&lang=css&"
import style1 from "./UOttawaTask5.vue?vue&type=style&index=1&id=35f6f7fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f6f7fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VDataTable,VIcon,VRow,VTextField})
